import React from "react";
import PropTypes from "prop-types";

import * as Theme from "../../../../App/Theme";

import HelpIcon from "../../../../Img/DM/Help 32 n p.png";

import GBStdTable from "../../../../Library/Tables/GBStdTableAG/GbStdTable";
import TComboBox from "../../../../Library/ComboBoxes/TComboBox";
import TLabel from "../../../../Library/Labels/TLabel";
import TDialog from "../../../../Library/Dialogs/TDialog";

import * as GBConst from "../../../GB/NonComponents/GBConst";
import { toBase10, getDelphiHexFromHexColor, shouldComponentUpdateGB } from "../../../GB/NonComponents/GBUtil";

import * as DMConst from "../../NonComponents/DMConst";
import { getYearIdx } from "../../NonComponents/DMUtil";
import { getVMMC_TargCov1DFltArray } from "../../NonComponents/DMDataUtil";
import TButton from "../../../../Library/Buttons/TButton";
import { API_URL_BASE, DMService } from "../../../../API/server_calls";

class DMCovTableByAgeCountryForm extends React.Component {
    static propTypes = {
        results: PropTypes.object,
        selectedCountryMstID: PropTypes.number,
        selectedFiscalYearStart: PropTypes.number,
        selectedProvinceCurrID: PropTypes.number,
        selectedSNU_CurrID: PropTypes.number,
        selectedTargetYear: PropTypes.number,
        showGlobalOutputsBool: PropTypes.bool,
        VMMC_Coverage: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
    };

    static defaultProps = {
        results: {},
        selectedCountryMstID: 1,
        selectedFiscalYearStart: DMConst.janFYS,
        selectedProvinceCurrID: 1,
        selectedSNU_CurrID: 1,
        selectedTargetYear: 0,
        showGlobalOutputsBool: false,
        VMMC_Coverage: [],
    };

    constructor(props) {
        super(props);

        this.state = {
            finalYear: DMConst.lastYearProgData,
            showHelpDialog: false,
        };
    }

    /* Avoid re-rendering if we don't have to (if no props or state affect this form). */
    shouldComponentUpdate(nextProps, nextState) {
        return shouldComponentUpdateGB(this.props, nextProps, this.state, nextState);
    }

    //==================================================================================================================
    //
    //                                                 Events
    //
    //==================================================================================================================

    onDownloadResultTableBtnClick = () => {
        try {
            const props = this.props;
            const selectedCountryMstID = props.selectedCountryMstID;
            const selectedFiscalYearStart = props.selectedFiscalYearStart;
            const selectedProvinceCurrID = props.selectedProvinceCurrID;
            const selectedSNU_CurrID = props.selectedSNU_CurrID;
            const selectedTargetYear = props.selectedTargetYear;
            const showGlobalOutputsBool = props.showGlobalOutputsBool;
            const VMMC_Coverage = props.VMMC_Coverage;

            DMService.generateResultLink(
                "result_output",
                10,
                selectedCountryMstID,
                selectedProvinceCurrID,
                selectedSNU_CurrID,
                selectedTargetYear,
                getVMMC_TargCov1DFltArray(VMMC_Coverage),
                true,
                showGlobalOutputsBool,
                selectedFiscalYearStart,

                (result) => {
                    let a = document.createElement("a");
                    a.href = API_URL_BASE + "/" + result;
                    a.download = "result_output.xlsx";
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                },
                () => {
                    alert("Could not download result.");
                }
            );
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onFinalYearComboBoxChange = (value, text, info) => {
        try {
            this.setState({
                finalYear: text,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onHelpBtnClick = () => {
        try {
            this.setState({
                showHelpDialog: !this.state.showHelpDialog,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    render() {
        try {
            const props = this.props;
            const results = props.results;
            const res = results[DMConst.rResult10];

            const state = this.state;
            const finalYear = state.finalYear;
            const showHelpDialog = state.showHelpDialog;

            const pointLabels = res[DMConst.rPointLabels];
            const subsetLabels = res[DMConst.rSubsetLabels];
            const data1 = res[DMConst.rData1];
            const numCountries = res[DMConst.rPoints];
            const numAgeGroups = res[DMConst.rSubsets];
            const title = res[DMConst.rTitle];

            const t2 = getYearIdx(finalYear) + 1;

            let chart = null;
            let noDataDiv = null;

            // if (t2 >= t1) {
            const numRows = numCountries + 1;
            const numCols = numAgeGroups + 1;

            let tableData2DArray = [];
            let lockedCells2DBoolArray = [];
            let cellBackgroundColor2DIntArray = [];

            const blueRomanceAsDec = toBase10(getDelphiHexFromHexColor(Theme.DM_BlueRomanceColor));
            const tangerineYellowAsDec = toBase10(getDelphiHexFromHexColor(Theme.DM_TangerineYellowColor));
            const mandyAsDec = toBase10(getDelphiHexFromHexColor(Theme.DM_MandyColor));

            let country = 1;
            for (let r = 1; r <= numRows; r++) {
                tableData2DArray.push([]);
                lockedCells2DBoolArray.push([]);
                cellBackgroundColor2DIntArray.push([]);

                let a = 1;
                for (let c = 1; c <= numCols; c++) {
                    /* Column headings (age groups) */
                    if (r === 1 && c >= 2) {
                        tableData2DArray[r - 1].push(subsetLabels[a]);
                    } else if (c === 1 && r >= 2) {
                    /* Row headings (countries) */
                        tableData2DArray[r - 1].push(pointLabels[country]);
                    } else if (c >= 2 && r >= 2) {
                    /* Coverage values */
                        const value = data1[country][a][t2];
                        tableData2DArray[r - 1].push(value);

                        if (parseInt(value, 10) < 50) {
                            cellBackgroundColor2DIntArray[r - 1].push(mandyAsDec);
                        } else if (parseInt(value, 10) >= 50 && parseInt(value, 10) <= 70) {
                            cellBackgroundColor2DIntArray[r - 1].push(tangerineYellowAsDec);
                        } else {
                            cellBackgroundColor2DIntArray[r - 1].push(blueRomanceAsDec);
                        }
                    } else {
                        tableData2DArray[r - 1].push("");
                    }

                    lockedCells2DBoolArray[r - 1].push(true);

                    if (c <= 1 || r <= 1) {
                        cellBackgroundColor2DIntArray[r - 1].push(GBConst.clNone);
                    }

                    /* Ignore row headings column. */
                    if (c !== 1) {
                        a++;
                    }
                }

                /* Ignore column headings row. */
                if (r !== 1) {
                    country++;
                }
            }

            let colWidths1DIntArray = [];
            colWidths1DIntArray.length = numCols;
            colWidths1DIntArray.fill(65);
            colWidths1DIntArray[0] = 250;

            const tableData = {
                value: tableData2DArray,
            };

            const packTable = {
                BandsOn: true,
                BGColors: cellBackgroundColor2DIntArray,
                GBColCount: numCols,
                GBColWidths: colWidths1DIntArray,
                GBFixedCols: 1,
                GBFixedRows: 1,
                GBRowCount: numRows,
                id: 1,
                LockedCells: lockedCells2DBoolArray,
                tableData: tableData,
            };

            const table = (
                <GBStdTable
                    headerBackgroundColor={Theme.HL_PrimaryColor}
                    oddRowBackgroundColor={Theme.HL_BandColor}
                    packTable={packTable}
                    onPackTableChanged={() => {}} // do nothing
                    style={{
                        marginLeft: Theme.indent,
                    }}
                    // width              = {900}
                />
            );
            // }
            // else {
            //     noDataDiv =
            //         <div
            //             style = {{
            //                 marginLeft : Theme.indent,
            //             }}
            //         >
            //             No data to display
            //         </div>;
            // }

            const tableTitleLabel = (
                <TLabel
                    caption={title}
                    style={{
                        fontWeight: "bold",
                        marginBottom: Theme.indent,
                        marginLeft: Theme.indent,
                        marginTop: Theme.indent,
                    }}
                />
            );

            const tableNoteDiv = (
                <div
                    style={{
                        backgroundColor: Theme.DM_HintOfGreenColor,
                        marginBottom: Theme.indent * 2,
                        marginLeft: Theme.indent,
                        padding: Theme.indent,
                    }}
                >
                    Color-coding: Green is above 70%, yellow is between 50% and 70% and red is below 50%. Cross-country
                    comparison (comparable to Result 4): Modeled estimates of MC coverage (%) by age group, for a
                    user-specified year. Color-coding represents level of coverage. When set to the current year, the MC
                    coverage is a result of program achievements through the end of the prior year. When set to future
                    years, the MC coverage is a result of progress toward user-specified coverage targets.
                </div>
            );

            const finalYearLabel = (
                <TLabel
                    caption={"End of"}
                    style={{
                        marginLeft: Theme.indent,
                    }}
                />
            );

            let year1DIntArray = [];

            for (let t = DMConst.firstYear; t <= DMConst.lastPossibleTargetYear - 1; t++) {
                year1DIntArray.push(t);
            }

            const finalYearComboBox = (
                <TComboBox
                    onChange={this.onFinalYearComboBoxChange}
                    itemIndex={finalYear - DMConst.firstYear}
                    items={year1DIntArray}
                    outerStyle={{
                        marginLeft: 5,
                        width: Theme.finalYearComboBoxWidth,
                    }}
                    style={Theme.finalYearComboBoxStyle}
                />
            );

            const downloadResultTableBtn = (
                <TButton
                    caption={"Download result table"}
                    onClick={this.onDownloadResultTableBtnClick}
                    containerStyle={{
                        marginLeft: Theme.indent * 3,
                    }}
                />
            );

            const helpBtn = (
                <div>
                    <img
                        alt="" // to avoid hint
                        onClick={this.onHelpBtnClick}
                        style={Theme.helpBtnImgStyle}
                        src={HelpIcon}
                    />
                </div>
            );

            const helpDialog = (
                <TDialog
                    caption={title}
                    content={
                        <div>
                            Color-coding: Green is above 70%, yellow is between 50% and 70% and red is below 50%.
                            Cross-country comparison (comparable to Result 4): Modeled estimates of MC coverage (%) by
                            age group, for a user-specified year. Color-coding represents level of coverage. When set to
                            the current year, the MC coverage is a result of program achievements through the end of the
                            prior year. When set to future years, the MC coverage is a result of progress toward
                            user-specified coverage targets.
                        </div>
                    }
                    actions={["mrOK"]}
                    onClose={this.onHelpBtnClick}
                    style={{
                        width: 1000,
                    }}
                    maxWidth={"xl"}
                    visible={showHelpDialog}
                />
            );

            const configLeftDiv = (
                <div style={Theme.configLeftDivStyle}>
                    {finalYearLabel}
                    {finalYearComboBox}
                    {downloadResultTableBtn}
                </div>
            );

            const configDiv = (
                <div style={Theme.configDivStyle}>
                    {configLeftDiv}
                    {helpBtn}
                </div>
            );

            const resultDiv = (
                <div
                    style={Theme.resultCenterDiv}
                    key={"resultDiv"}
                >
                    {chart}
                    {tableTitleLabel}
                    {tableNoteDiv}
                    {noDataDiv}
                    {table}
                    {helpDialog}
                </div>
            );

            return (
                <div key={"DMCovTableByAgeCountryFormDiv"}>
                    {resultDiv}
                    {configDiv}
                </div>
            );
        } catch (exception) {
            return (
                <div
                    className={"DMCovTableByAgeCountryFormDiv"}
                    key={"DMCovTableByAgeCountryFormDiv"}
                >
                    <h3 key={"DMCovTableByAgeCountryFormDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default DMCovTableByAgeCountryForm;
